export default "__VITE_ASSET__B00mo1d7__"